import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilled, ButtonFilledAutoWidth } from '../../../components/button'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { CreateDepartmentService, UpdateDepartmentService } from '../../../services/DepartmentServices'
import { useNavigate, useLocation } from 'react-router-dom'
import { MobileBackOption } from '../../../components/appbars/mobile/DashboardMobile'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { message, Select } from 'antd'
import { CreateClassStreamService, GetClassStreamService, UpdateClassStreamService } from '../../../services/admin/StudentStreamServices'

function StudentStreamCE() {
 
  const [data,setdata] = useState({name:'',label:'',parent_stream:'',match_string:''});  
  const [error,seterror] = useState({name:'',label:'',parent_stream:'',match_string:''}); 
  const [streamlist,setstreamlist] = useState([]);

  const {state} = useLocation();
  const navigate = useNavigate();

  useEffect(()=>{
    getStreamList()
  },[])

  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      setdata({...data,...state})
    }
  },[state])
   
  console.log(streamlist,'data') 

  async function getStreamList(){
    const response = await GetClassStreamService()
    setstreamlist(response.data.datas?.filter(f=>f?.parent_stream === undefined)?.map((d)=>({value:d._id,label:d.name})))
  }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.name){
        seterror({...error,name:'Name field is required *'})
    }else if(!data.label){
        seterror({...error,label:'Label field is required *'})
    }else if(!data.match_string){
        seterror({...error,match_string:'Match String field is required *'})
    }else{

        let send_data = {...data}
        if(send_data.parent_stream === ''){
          delete send_data.parent_stream
        }else{
          send_data.parent_stream = data.parent_stream?.value
        }
        if(state?._id === undefined || state?._id === null){
        const response = await CreateClassStreamService(send_data)
        if (response.status === 201) {
          resetform()
          getStreamList()
          toast.success('Class Stream Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
        let send_data = {...data}
        if(send_data.parent_stream === ''){
          delete send_data.parent_stream
        }else{
          send_data.parent_stream = data.parent_stream?.value
        }
        const response = await UpdateClassStreamService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          getStreamList()
          navigate(-1)
          toast.success('Class Stream Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
  }
  }


  function resetform(){
    setdata({name:'',label:'',parent_stream:'',match_string:''})
    seterror({name:'',label:'',parent_stream:'',match_string:''})
  }

  async function handleSelect(e,e1){
    if(e1 === 'parent_stream'){
      const selectedStream = streamlist?.find(ele => ele.value === e);
      setdata({...data,parent_stream:selectedStream})
      seterror({...error,parent_stream:''})
    }
  }
  

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Student Stream</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Student Stream</b> for your clients segregate followup.</h6>
     

        <TextInput 
            label={'Name'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <div>
            <h6 className='text-[11px] mb-1 mt-2'>Parent Stream </h6>
              <Select
                value={data.parent_stream} 
                filterOption={false}
                bordered={false}
                placeholder="" 
                onChange={(e)=>handleSelect(e,'parent_stream')} 
                options={streamlist} 
                className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
    
                />
          </div> 

          <TextInput 
            label={'Label'}  
            variant="standard"
            name="label"
            type="text"
            error={error.label}
            value={data.label}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>  

             <TextAreaInput1 
            label={'Match String'}  
            variant="standard"
            name="match_string"
            type="text"
            error={error.match_string}
            value={data.match_string}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE STUDENT STREAM" : "ADD STUDENT STREAM"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default StudentStreamCE